/* V40 §5–§9 — „PASIRINK SAVO MUZIKINĮ" rekomendatorius.
   Jokio AI, jokio runtime teksto generavimo: paaiškinimai sudedami iš
   iš anksto parašytų fragmentų. Visos reikšmės ateina iš game-finder.liquid. */
(function () {
  'use strict';

  var OWNED_KEY = 'mz_owned_full_games_v2';
  var OLD_KEY = 'mz_owned_products';
  var FULL = ['muzikinis-zaidimas', 'muzikinis-zaidimas-x-agata', 'muzikinis-zaidimas-x-kernagis'];

  function owned() {
    var list = null;
    try { list = JSON.parse(localStorage.getItem(OWNED_KEY)); } catch (e) {}
    if (!Array.isArray(list)) {
      try { list = JSON.parse(localStorage.getItem(OLD_KEY)); } catch (e) {}
    }
    if (!Array.isArray(list)) return [];
    return list.filter(function (h) { return FULL.indexOf(h) !== -1; });
  }

  function money(cents) {
    if (window.MZ && window.MZ.money) return window.MZ.money(cents);
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function dist(a, b) {
    return Math.pow(a.younger - b.younger, 2) +
           Math.pow(a.older - b.older, 2) +
           Math.pow(a.difficulty - b.difficulty, 2);
  }

  /* §9 — dinaminis paaiškinimas iš fiksuotų fragmentų */
  function choiceLine(user) {
    var bits = [];
    if (user.younger >= 7) bits.push('daugiau naujesnės muzikos');
    if (user.older >= 7) bits.push('daugiau vyresnės kartos repertuaro');
    if (user.difficulty >= 7) bits.push('didesnį iššūkį');
    else if (user.difficulty <= 4) bits.push('mažesnį sunkumą');
    if (!bits.length) return 'Pasirinkai subalansuotą profilį.';
    if (bits.length === 1) return 'Pasirinkai ' + bits[0] + '.';
    return 'Pasirinkai ' + bits.slice(0, -1).join(', ') + ' ir ' + bits[bits.length - 1] + '.';
  }

  function GameFinder(root) {
    /* V73 · PERF-001 — IDEMPOTENT INIT.
       `init()` kviečiamas ir per DOMContentLoaded, ir per
       `shopify:section:load`. Be šios apsaugos tas pats elementas
       theme editoriuje inicializuojamas kartotinai: dubliuojasi
       listeneriai, o kai kur ir tinklo užklausos. Vienas elementas —
       viena inicializacija. */
    if (root.dataset.gfReady === '1') return;
    root.dataset.gfReady = '1';

    var dataEl = root.querySelector('[data-gf-data]');
    if (!dataEl) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!DATA || !DATA.products || !DATA.products.length) { root.hidden = true; return; }

    var byHandle = {};
    DATA.products.forEach(function (p) { byHandle[p.handle] = p; });

    var ranges = root.querySelectorAll('[data-gf-range]');
    var outs = {};
    root.querySelectorAll('[data-gf-out]').forEach(function (o) { outs[o.dataset.gfOut] = o; });

    var elMedia = root.querySelector('[data-gf-media]');
    var elKicker = root.querySelector('[data-gf-kicker]');
    var elTitle = root.querySelector('[data-gf-title]');
    var elFacts = root.querySelector('[data-gf-facts]');
    var elWhy = root.querySelector('[data-gf-why]');
    var elPrice = root.querySelector('[data-gf-price]');
    var elAdd = root.querySelector('[data-gf-add]');
    var elLink = root.querySelector('[data-gf-link]');
    var elOwned = root.querySelector('[data-gf-owned]');
    var card = root.querySelector('[data-gf-card]');

    var user = { younger: 5, older: 5, difficulty: 5 };

    function buyable(p) {
      return p && p.available !== false && p.variant;
    }

    /* Kandidatai: tik pirkti galimi ir dar neturimi pilni žaidimai. */
    function candidates(have) {
      return DATA.products.filter(function (p) {
        if (!buyable(p)) return false;                   /* išparduotas praleidžiamas */
        if (have.indexOf(p.handle) !== -1) return false; /* jau turi */
        return true;
      });
    }

    /* V43 §7 — rezultatas visada yra VIENAS pilnas žaidimas.
       Ankstesnė „papildymas virsta rinkiniu" logika pašalinta, nes į kandidatų
       sąrašą papildymai nebepatenka (žr. gf_handles sekcijoje). */
    function resolve(best) {
      return { items: [best], bundle: false };
    }

    function render() {
      var have = owned();
      if (elOwned) elOwned.hidden = have.length === 0;

      var pool = candidates(have);
      if (!pool.length) { card.hidden = true; return; }
      card.hidden = false;

      var best = pool[0];
      var bestD = dist(user, best.profile);
      pool.forEach(function (p) {
        var d = dist(user, p.profile);
        if (d < bestD) { bestD = d; best = p; }
      });

      var res = resolve(best);
      var items = res.items;

      /* Nuotraukos: viena arba dvi 50/50. Niekada nepersidengia. */
      elMedia.className = 'gfcard__media' + (items.length > 1 ? ' gfcard__media--two' : '');
      elMedia.innerHTML = '';
      items.forEach(function (p) {
        var fig = document.createElement('div');
        fig.className = 'gfcard__shot media media--packshot';
        if (p.image) {
          var img = document.createElement('img');
          img.src = p.image;
          img.alt = p.title;
          img.loading = 'lazy';
          img.width = 700;
          img.height = 700;
          fig.appendChild(img);
        }
        elMedia.appendChild(fig);
      });

      elKicker.textContent = items.length > 1 ? 'Rinkinys' : (items[0].kicker || '');
      elTitle.textContent = items.map(function (p) { return p.title; }).join(' + ');

      /* 2–3 faktai. Rinkiniui — po vieną svarbiausią iš kiekvieno. */
      var facts = items.length > 1
        ? [items[0].facts[0], items[1].facts[0], items[1].facts[1]]
        : items[0].facts.slice(0, 3);
      /* V117 §8 — trys lygiavertės celės su canonical ikonomis.
         Tvarka duomenyse jau yra songs / period / player, todėl ikona
         parenkama pagal indeksą. URL'us paduoda Liquid (`data-gf-icons`),
         kad kelias į assetus liktų vienoje vietoje. */
      var iconHost = root.querySelector('[data-gf-icons]');
      var iconKeys = ['songs', 'period', 'player'];
      elFacts.innerHTML = '';
      facts.forEach(function (f, i) {
        if (!f) return;
        var li = document.createElement('li');
        var src = iconHost && iconHost.dataset['icon' + iconKeys[i].charAt(0).toUpperCase() + iconKeys[i].slice(1)];
        if (src) {
          var ico = document.createElement('img');
          ico.className = 'gfcard__fico';
          ico.src = src;
          ico.alt = '';
          ico.setAttribute('aria-hidden', 'true');
          ico.width = 52;
          ico.height = 52;
          ico.loading = 'lazy';
          li.appendChild(ico);
        }
        /* V119: trečias faktas ateina kaip „GROJA|per …" — didelis
           užrašas ir maža eilutė po juo, kaip produkto kortelėje. */
        var parts = String(f).split('|');
        var txt = document.createElement('span');
        txt.className = 'gfcard__factmain';
        txt.textContent = parts[0];
        li.appendChild(txt);
        if (parts[1]) {
          var sub = document.createElement('span');
          sub.className = 'gfcard__factsub';
          sub.textContent = parts[1];
          li.appendChild(sub);
        }
        elFacts.appendChild(li);
      });

      /* Reitingas: klonuojamas Liquid paruoštas `product-review-meta`.
         Vienam produktui — vienas blokas; rinkiniui rodomas pirmojo. */
      var elRating = root.querySelector('[data-gf-rating]');
      if (elRating) {
        elRating.innerHTML = '';
        var tpl = root.querySelector('[data-gf-rating-for="' + items[0].handle + '"]');
        if (tpl && 'content' in tpl) elRating.appendChild(tpl.content.cloneNode(true));
      }

      /* Paaiškinimas: pasirinkimo santrauka + produkto sakinys. Jokio runtime teksto. */
      elWhy.textContent = choiceLine(user) + ' ' + items[0].why;

      var total = items.reduce(function (sum, p) { return sum + p.price; }, 0);
      elPrice.textContent = money(total);

      elAdd.setAttribute('data-add-variant', items[0].variant);
      elAdd.textContent = 'Dėti į krepšelį';
      elLink.setAttribute('href', items[0].url);
    }

    function lower(s) {
      if (!s) return '';
      return s.charAt(0).toLowerCase() + s.slice(1);
    }

    ranges.forEach(function (r) {
      r.addEventListener('input', function () {
        var v = parseInt(r.value, 10) || 5;
        user[r.dataset.gfRange] = v;
        r.setAttribute('aria-valuetext', v + ' iš 10');
        if (outs[r.dataset.gfRange]) outs[r.dataset.gfRange].textContent = v + '/10';
        render();
      });
    });

    document.addEventListener('mz:owned', render);
    render();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gfind]').forEach(GameFinder);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
